const state = () => ({
  hideMenu: false,
  hideMobileMenu: true
});
const mutations = {
  setHiddenMenu(state, userData) {
    state.hideMenu = userData.value;
  },
  setHiddenMobileMenu(state, userData) {
    state.hideMobileMenu = userData.value;
  }
};
const actions = {
  AutoHideMenu({ commit }) {
    if (localStorage.getItem("IsMenuHidden") == "true") {
      commit("setHiddenMenu", {
        value: true
      });
    } else {
      commit("setHiddenMenu", {
        value: false
      });
    }
  }
};
const getters = {
  ifHideMenu: state => {
    return state.hideMenu;
  },
  ifHideMobileMenu: state => {
    return state.hideMobileMenu;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
